module.exports = __webpack_public_path__ + "media/images/home/card_cqf-8606cc9cee8484a224939d0a06c73231.jpg";